/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Directory_Promotion_StepInputs */

const en_directory_promotion_step = /** @type {(inputs: Directory_Promotion_StepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Step ${i?.current} of ${i?.total}`)
};

const zh_directory_promotion_step = /** @type {(inputs: Directory_Promotion_StepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.current} 步，共 ${i?.total} 步`)
};

/**
* | output |
* | --- |
* | "Step {current} of {total}" |
*
* @param {Directory_Promotion_StepInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_step = /** @type {((inputs: Directory_Promotion_StepInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_StepInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_step(inputs)
	return zh_directory_promotion_step(inputs)
});
export { directory_promotion_step as "directory.promotion.step" }